/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const DatePickerSkeleton = _ref => {
  let {
    range,
    id,
    hideLabel,
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const dateInput = /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--date-picker-container`
  }, !hideLabel && /*#__PURE__*/React__default.createElement("span", {
    className: `${prefix}--label`,
    id: id
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--date-picker__input ${prefix}--skeleton`
  }));
  if (range) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: `${prefix}--form-item`
    }, /*#__PURE__*/React__default.createElement("div", _extends({
      className: cx(`${prefix}--date-picker`, `${prefix}--date-picker--range`, `${prefix}--skeleton`, className)
    }, rest), dateInput, dateInput));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--form-item`
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx(`${prefix}--date-picker`, `${prefix}--date-picker--short`, `${prefix}--date-picker--simple`, `${prefix}--skeleton`, className)
  }, rest), dateInput));
};
DatePickerSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * Specify whether the label should be hidden, or not
   */
  hideLabel: PropTypes.bool,
  /**
   * Specify the id to add.
   */
  id: PropTypes.string,
  /**
   * Specify whether the skeleton should be of range date picker.
   */
  range: PropTypes.bool
};

export { DatePickerSkeleton, DatePickerSkeleton as default };
